export default "__VITE_ASSET__e19994b6__"